import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const CompiParameters = () => {
  const [competitions, setCompetitions] = useState([]);

  const navigate = useNavigate();

  const fetchAllCompetitions = () => {
    Axios.get("https://ashish.moodi.org/competitions/get_all_compi")
      .then((res) => setCompetitions(res.data))
      .catch((err) => console.error(err));
  };

  console.log("compo", competitions);

  useEffect(() => {
    // ACCESS ONLY TO ADMIN COORDIE
    if (localStorage.getItem("compiauthtoken")) {
      fetchAllCompetitions();
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid">
      <h2>Add/Change Competition Parameters</h2>
      <ul>
        {competitions.map((competition) => {
          return (
            <li>
              <Link to={`/admin/parameters/${competition.competitionName}`}>
                {competition.competitionName}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CompiParameters;
